import React, { useState, useEffect } from "react";
import { connect, useSelector } from "react-redux";
import {
  Container,
  Card,
  Form,
  Row,
  Col,
  Button,
  Alert,
} from "react-bootstrap";
import { changePassword, resetUpdatePass } from "../../actions/auth-action";
import { changeName } from "../../actions/setting-action";
import GADialog from "../common/GADialog";
import "./AccountPanel.scss";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

const labelWidth = 3;

const AccountPanel = (props) => {
  const { changePassword, resetUpdatePass,changeName } = props;
  const [currPass, setCurrPass] = useState("");
  const [newPass, setNewPass] = useState("");
  const [repeatPass, setRepeatPass] = useState("");
  const [showGADialog, setShowGADialog] = useState(false);
  const {t} = useTranslation()
  
  

  const email = useSelector((state) => state.auth.user.email);
  const name = useSelector((state) => state.settings.user.name?state.settings.user.name:state.auth.user.name);
  const hasPassword = useSelector((state) => state.auth.user.has_password);
  const updatePassStart = useSelector((state) => state.auth.updatePassStart);
  const updateProfileStart = useSelector((state) => state.settings.updateProfileStart);
  const gaEnabled = useSelector((state) => state.settings.gaEnabled) || false;
  const updatePassSuccess = useSelector(
    (state) => state.auth.updatePassSuccess
  );
  const [newName,updateName] = useState(name)
  const updatePassError = useSelector((state) => state.auth.updatePassError);

  useEffect(() => {
    resetUpdatePass();
    return () => {
      resetUpdatePass();
    };
  }, []);

  const clickChangePass = () => {
    if (gaEnabled) {
      setShowGADialog(true);
    } else {
      saveChange();
    }
  };

  const saveChange = () => {
    changePassword({
      old_password: currPass,
      password: newPass,
      password_confirmation: repeatPass,
    });
  };
  const clickChangeName = () => {
    changeName({
      name: newName
    })
      .then(() => {
        toast.success(t("update-success"))
      })
      .catch((err) => toast.error(err));
  };

  return (
    <>
      <div className="account-panel round-bg">
        <Form.Group as={Row}>
          <Form.Label column sm={labelWidth} className="text-title">
            {t("email")}
          </Form.Label>
          <Col sm={12 - labelWidth}>
            <Form.Control plaintext readOnly defaultValue={email} />
          </Col>
        </Form.Group>
        <Form.Group as={Row}>
          <Form.Label column sm={labelWidth}>
            {t("name")}
          </Form.Label>
          <Col sm={8}>
            <Form.Control type="text"  value={newName} onChange={(e)=>updateName(e.target.value)}/>
          </Col>
        </Form.Group>
        <Row className="justify-content-center mt-4">
              <Button onClick={clickChangeName} variant="success">
                {updateProfileStart ? t("updating") : t("update")}
              </Button>
            </Row>
        </div>
        <div className="account-panel round-bg" style={{marginTop:'10px'}}>
        {hasPassword == 1 ? (
          <>
            <Form.Group as={Row}>
              <Form.Label column sm={labelWidth}>
                {t("current-p")}
              </Form.Label>
              <Col sm={12 - labelWidth}>
                <Form.Control
                  type="password"
                  value={currPass}
                  onChange={(e) => setCurrPass(e.target.value)}
                />
              </Col>
            </Form.Group>
            <Form.Group as={Row}>
              <Form.Label column sm={labelWidth}>
                {t("new-pass")}
              </Form.Label>
              <Col sm={12 - labelWidth}>
                <Form.Control
                  type="password"
                  value={newPass}
                  onChange={(e) => setNewPass(e.target.value)}
                />
              </Col>
            </Form.Group>
            <Form.Group as={Row}>
              <Form.Label column sm={labelWidth}>
                {t("re-pass")}
              </Form.Label>
              <Col sm={12 - labelWidth}>
                <Form.Control
                  type="password"
                  value={repeatPass}
                  onChange={(e) => setRepeatPass(e.target.value)}
                />
              </Col>
            </Form.Group>

            <Row className="justify-content-center mt-4">
              <Button onClick={clickChangePass} variant="success">
                {updatePassStart ? t("updating") : t("change-pass")}
              </Button>
            </Row>
            <Row className="justify-content-center mt-2">
              <Alert
                show={updatePassError || updatePassSuccess}
                variant={updatePassError ? "danger" : "success"}
              >
                {updatePassError || t("update-success")}
              </Alert>
            </Row>
          </>
        ) : (
          <></>
        )}
      </div>
      <GADialog
        show={showGADialog}
        onHide={() => setShowGADialog(false)}
        success={saveChange}
      />
    </>
  );
};

export default connect(null, { changePassword, resetUpdatePass,changeName })(AccountPanel);
